//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.18.0.0 (NJsonSchema v10.8.0.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { AnonymousApiBase } from "./AnonymousApiBase";import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class SignUpClient extends AnonymousApiBase {
    private instance: AxiosInstance;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance ? instance : axios.create();

        this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : this.getBaseUrl("");

    }

    /**
     * @param body (optional) 
     * @return Success
     */
    signUp(aadToken: string, body?: CreateOrganisationAppSourceRequest | undefined , cancelToken?: CancelToken | undefined): Promise<CreateOrganisationResponse> {
        let url_ = this.baseUrl + "/signUp?";
        if (aadToken === undefined || aadToken === null)
            throw new Error("The parameter 'aadToken' must be defined and cannot be null.");
        else
            url_ += "aadToken=" + encodeURIComponent("" + aadToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json-patch+json",
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSignUp(_response);
        });
    }

    protected processSignUp(response: AxiosResponse): Promise<CreateOrganisationResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = CreateOrganisationResponse.fromJS(resultData200);
            return Promise.resolve<CreateOrganisationResponse>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<CreateOrganisationResponse>(null as any);
    }

    /**
     * @return Success
     */
    aadGetData(aadToken: string , cancelToken?: CancelToken | undefined): Promise<SaasSubscriptions> {
        let url_ = this.baseUrl + "/signUp/AadGetData?";
        if (aadToken === undefined || aadToken === null)
            throw new Error("The parameter 'aadToken' must be defined and cannot be null.");
        else
            url_ += "aadToken=" + encodeURIComponent("" + aadToken) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAadGetData(_response);
        });
    }

    protected processAadGetData(response: AxiosResponse): Promise<SaasSubscriptions> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SaasSubscriptions.fromJS(resultData200);
            return Promise.resolve<SaasSubscriptions>(result200);

        } else if (status === 404) {
            const _responseText = response.data;
            return throwException("Not Found", status, _responseText, _headers);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SaasSubscriptions>(null as any);
    }
}

export class CreateOrganisationAppSourceRequest implements ICreateOrganisationAppSourceRequest {
    name!: string;
    email!: string;
    companyName!: string;
    companyEmail!: string;
    companyTin!: string;
    companyAddress!: string;

    constructor(data?: ICreateOrganisationAppSourceRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.email = _data["email"];
            this.companyName = _data["companyName"];
            this.companyEmail = _data["companyEmail"];
            this.companyTin = _data["companyTin"];
            this.companyAddress = _data["companyAddress"];
        }
    }

    static fromJS(data: any): CreateOrganisationAppSourceRequest {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganisationAppSourceRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["email"] = this.email;
        data["companyName"] = this.companyName;
        data["companyEmail"] = this.companyEmail;
        data["companyTin"] = this.companyTin;
        data["companyAddress"] = this.companyAddress;
        return data;
    }
}

export interface ICreateOrganisationAppSourceRequest {
    name: string;
    email: string;
    companyName: string;
    companyEmail: string;
    companyTin: string;
    companyAddress: string;
}

export class CreateOrganisationResponse implements ICreateOrganisationResponse {

    constructor(data?: ICreateOrganisationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): CreateOrganisationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new CreateOrganisationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface ICreateOrganisationResponse {
}

export class Beneficiary implements IBeneficiary {
    emailId?: string | undefined;
    objectId?: string | undefined;
    tenantId?: string | undefined;
    puid?: string | undefined;

    constructor(data?: IBeneficiary) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailId = _data["emailId"];
            this.objectId = _data["objectId"];
            this.tenantId = _data["tenantId"];
            this.puid = _data["puid"];
        }
    }

    static fromJS(data: any): Beneficiary {
        data = typeof data === 'object' ? data : {};
        let result = new Beneficiary();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailId"] = this.emailId;
        data["objectId"] = this.objectId;
        data["tenantId"] = this.tenantId;
        data["puid"] = this.puid;
        return data;
    }
}

export interface IBeneficiary {
    emailId?: string | undefined;
    objectId?: string | undefined;
    tenantId?: string | undefined;
    puid?: string | undefined;
}

export class Purchaser implements IPurchaser {
    emailId?: string | undefined;
    objectId?: string | undefined;
    tenantId?: string | undefined;
    puid?: string | undefined;

    constructor(data?: IPurchaser) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.emailId = _data["emailId"];
            this.objectId = _data["objectId"];
            this.tenantId = _data["tenantId"];
            this.puid = _data["puid"];
        }
    }

    static fromJS(data: any): Purchaser {
        data = typeof data === 'object' ? data : {};
        let result = new Purchaser();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["emailId"] = this.emailId;
        data["objectId"] = this.objectId;
        data["tenantId"] = this.tenantId;
        data["puid"] = this.puid;
        return data;
    }
}

export interface IPurchaser {
    emailId?: string | undefined;
    objectId?: string | undefined;
    tenantId?: string | undefined;
    puid?: string | undefined;
}

export class Term implements ITerm {
    termUnit?: string | undefined;

    constructor(data?: ITerm) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.termUnit = _data["termUnit"];
        }
    }

    static fromJS(data: any): Term {
        data = typeof data === 'object' ? data : {};
        let result = new Term();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["termUnit"] = this.termUnit;
        return data;
    }
}

export interface ITerm {
    termUnit?: string | undefined;
}

export class Subscription implements ISubscription {
    id?: string | undefined;
    publisherId?: string | undefined;
    offerId?: string | undefined;
    name?: string | undefined;
    saasSubscriptionStatus?: string | undefined;
    beneficiary?: Beneficiary;
    purchaser?: Purchaser;
    planId?: string | undefined;
    term?: Term;
    autoRenew?: boolean;
    isTest?: boolean;
    isFreeTrial?: boolean;
    allowedCustomerOperations?: string[] | undefined;
    sandboxType?: string | undefined;
    created?: Date;
    lastModified?: Date;
    sessionMode?: string | undefined;

    constructor(data?: ISubscription) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.publisherId = _data["publisherId"];
            this.offerId = _data["offerId"];
            this.name = _data["name"];
            this.saasSubscriptionStatus = _data["saasSubscriptionStatus"];
            this.beneficiary = _data["beneficiary"] ? Beneficiary.fromJS(_data["beneficiary"]) : <any>undefined;
            this.purchaser = _data["purchaser"] ? Purchaser.fromJS(_data["purchaser"]) : <any>undefined;
            this.planId = _data["planId"];
            this.term = _data["term"] ? Term.fromJS(_data["term"]) : <any>undefined;
            this.autoRenew = _data["autoRenew"];
            this.isTest = _data["isTest"];
            this.isFreeTrial = _data["isFreeTrial"];
            if (Array.isArray(_data["allowedCustomerOperations"])) {
                this.allowedCustomerOperations = [] as any;
                for (let item of _data["allowedCustomerOperations"])
                    this.allowedCustomerOperations!.push(item);
            }
            this.sandboxType = _data["sandboxType"];
            this.created = _data["created"] ? new Date(_data["created"].toString()) : <any>undefined;
            this.lastModified = _data["lastModified"] ? new Date(_data["lastModified"].toString()) : <any>undefined;
            this.sessionMode = _data["sessionMode"];
        }
    }

    static fromJS(data: any): Subscription {
        data = typeof data === 'object' ? data : {};
        let result = new Subscription();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["publisherId"] = this.publisherId;
        data["offerId"] = this.offerId;
        data["name"] = this.name;
        data["saasSubscriptionStatus"] = this.saasSubscriptionStatus;
        data["beneficiary"] = this.beneficiary ? this.beneficiary.toJSON() : <any>undefined;
        data["purchaser"] = this.purchaser ? this.purchaser.toJSON() : <any>undefined;
        data["planId"] = this.planId;
        data["term"] = this.term ? this.term.toJSON() : <any>undefined;
        data["autoRenew"] = this.autoRenew;
        data["isTest"] = this.isTest;
        data["isFreeTrial"] = this.isFreeTrial;
        if (Array.isArray(this.allowedCustomerOperations)) {
            data["allowedCustomerOperations"] = [];
            for (let item of this.allowedCustomerOperations)
                data["allowedCustomerOperations"].push(item);
        }
        data["sandboxType"] = this.sandboxType;
        data["created"] = this.created ? this.created.toISOString() : <any>undefined;
        data["lastModified"] = this.lastModified ? this.lastModified.toISOString() : <any>undefined;
        data["sessionMode"] = this.sessionMode;
        return data;
    }
}

export interface ISubscription {
    id?: string | undefined;
    publisherId?: string | undefined;
    offerId?: string | undefined;
    name?: string | undefined;
    saasSubscriptionStatus?: string | undefined;
    beneficiary?: Beneficiary;
    purchaser?: Purchaser;
    planId?: string | undefined;
    term?: Term;
    autoRenew?: boolean;
    isTest?: boolean;
    isFreeTrial?: boolean;
    allowedCustomerOperations?: string[] | undefined;
    sandboxType?: string | undefined;
    created?: Date;
    lastModified?: Date;
    sessionMode?: string | undefined;
}

export class SaasSubscriptions implements ISaasSubscriptions {
    id?: string | undefined;
    subscriptionName?: string | undefined;
    offerId?: string | undefined;
    planId?: string | undefined;
    subscription?: Subscription;

    constructor(data?: ISaasSubscriptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.subscriptionName = _data["subscriptionName"];
            this.offerId = _data["offerId"];
            this.planId = _data["planId"];
            this.subscription = _data["subscription"] ? Subscription.fromJS(_data["subscription"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SaasSubscriptions {
        data = typeof data === 'object' ? data : {};
        let result = new SaasSubscriptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["subscriptionName"] = this.subscriptionName;
        data["offerId"] = this.offerId;
        data["planId"] = this.planId;
        data["subscription"] = this.subscription ? this.subscription.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISaasSubscriptions {
    id?: string | undefined;
    subscriptionName?: string | undefined;
    offerId?: string | undefined;
    planId?: string | undefined;
    subscription?: Subscription;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}